(() => {
  const linksWrapper = document.querySelector(".shop-by-product_links");
  const card = document.querySelector(".mega-menu-product-card.featured-product");

  if (!linksWrapper || !card) return;

  const img = card.querySelector("img");
  const titleEl = card.querySelector(".product-title");
  const featureEl = card.querySelector(".product-feature");
  const badgeEl = card.querySelector(".bs-badge");

  const getCountEl = () => card.querySelector(".oke-sr-count-number");

  const original = {
    href: card.getAttribute("href") || "",
    imgSrc: img?.getAttribute("src") || "",
    imgAlt: img?.getAttribute("alt") || "",
    title: titleEl?.textContent?.trim() || "",
    feature: featureEl?.textContent?.trim() || "",
    badge: badgeEl?.textContent?.trim() || "",
    reviewsCount: getCountEl()?.textContent?.trim() || "",
  };

  const decodeHtml = (str = "") => {
    const t = document.createElement("textarea");
    t.innerHTML = str;
    return t.value;
  };

  const extractReviewCount = (reviewsStr = "") => {
    if (!reviewsStr) return "";

    const decoded = decodeHtml(reviewsStr);
    const tmp = document.createElement("div");
    tmp.innerHTML = decoded;

    const count = tmp.querySelector(".oke-sr-count-number")?.textContent?.trim();
    return count || "";
  };

  const restoreOriginal = () => {
    card.setAttribute("href", original.href);

    if (img) {
      img.setAttribute("src", original.imgSrc);
      img.setAttribute("alt", original.imgAlt);
    }

    if (titleEl) titleEl.textContent = original.title;
    if (featureEl) {
      featureEl.textContent = original.feature;
      featureEl.style.display = original.feature ? "" : "none";
    }

    if (badgeEl) {
      badgeEl.textContent = original.badge;
      badgeEl.style.display = original.badge ? "" : "none";
    }

    const countEl = getCountEl();
    if (countEl) countEl.textContent = original.reviewsCount;
  };

  const applyFromLink = (link) => {
    if (!link) return;

    const { productTitle, description, featureImage, reviews } = link.dataset;

    // Description (custom.collection_first_bullet_point) is optional on AU products
    if (!productTitle || !featureImage) {
      restoreOriginal();
      return;
    }

    card.setAttribute("href", link.getAttribute("href") || original.href);

    if (img) {
      img.setAttribute("src", featureImage);
      img.setAttribute("alt", `${productTitle} - Happy Mammoth`);
    }

    if (titleEl) titleEl.textContent = productTitle;
    if (featureEl) {
      featureEl.textContent = description || "";
      featureEl.style.display = description ? "" : "none";
    }

    const tag = link.querySelector(".tag-best-seller")?.textContent?.trim() || "";
    if (badgeEl) {
      if (tag) {
        badgeEl.style.display = "";
        badgeEl.textContent = tag;
      } else {
        badgeEl.style.display = "none";
      }
    }

    const newCount = extractReviewCount(reviews);
    const countEl = getCountEl();
    if (countEl) countEl.textContent = newCount || original.reviewsCount;
  };

  linksWrapper.querySelectorAll("a").forEach((link) => {
    link.addEventListener("mouseenter", () => applyFromLink(link));
    link.addEventListener("focus", () => applyFromLink(link));
  });

  linksWrapper.addEventListener("mouseleave", restoreOriginal);
  linksWrapper.addEventListener("focusout", (e) => {
    if (!linksWrapper.contains(e.relatedTarget)) restoreOriginal();
  });
})();
